import { getNumericParam, setParamIfDefined, setParamIfUndefined, toUrl } from "../utils.js";
export const parse = url => {
  const parsedUrl = toUrl(url);
  const width = getNumericParam(parsedUrl, "width");
  const height = getNumericParam(parsedUrl, "height");
  const params = {};
  parsedUrl.searchParams.forEach((value, key) => {
    params[key] = value;
  });
  parsedUrl.search = "";
  return {
    width,
    height,
    base: parsedUrl.toString(),
    params,
    cdn: "bunny"
  };
};
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height
  } = _ref;
  const url = toUrl(originalUrl);
  setParamIfDefined(url, "width", width, true, true);
  if (width && height) {
    setParamIfUndefined(url, "aspect_ratio", width + ":" + height);
  }
  return url;
};